<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title"> {{characteristicType === 'LoanCharacteristic' ? t('wizard.characteristics.loanCharacteristicsPreview') : t('wizard.characteristics.borrowerCharacteristicsPreview')}} </h5>
  <button type="button" class="btn-close" (click)="activeModal.close()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <!-- TODO: Review tracking - tasksPreview items may need a stable ID property -->
  @for (byCategoryId of tasksPreview | groupBy: 'taskCategoryId'; track byCategoryId.key; let i = $index) {
    <div class="row">
        <h5 class="card-title mb-2">{{ t('wizard.characteristics.tasksTriggeredBy', { name: getTaskCategoryName(byCategoryId.key) }) }}</h5>
        <hr>
        <!-- TODO: Review tracking - grouped items may need a stable ID property -->
        @for (byBorrower of byCategoryId.value | groupBy: 'borrowerId'; track byBorrower.key; let j = $index) {
          <div class="mb-4">
            @if (byBorrower.key) {
              <p style="margin-bottom: 0;">{{ t('wizard.characteristics.forBorrower', { name: getBorrowerName(byBorrower.key) }) }}</p>
            }
            <!-- TODO: Review tracking - task items may need a stable ID property -->
            @for (task of byBorrower.value; track $index) {
              <div>
                <input class="form-control mx-2" type="text" [(ngModel)]="task.description" name="description_{{byCategoryId.key}}_{{byBorrower.key}}">
              </div>
            }
          </div>
        }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('cancel')" data-bs-dismiss="modal"> {{ t('common.cancel') }}</button>
  <button type="button" (click)="onSaveClicked()" class="btn btn-primary">{{ t('common.save') }}</button>
</div>
</ng-container>
